// Constants.
// -----------------------------------------------------------------------------
export const BUTTON_GROUP_DEFAULT_ORIENTATION = 'horizontal';
//# sourceMappingURL=ButtonGroup.constants.js.map